import routes from '@/modules/notifications/notifications-routes';
import store from '@/modules/notifications/notifications-store';
export default {
    components: [],
    routes,
    store,
};
